<ng-container *transloco="let t; read: 'login'">
  <div class="p-d-flex p-flex-column p-jc-center p-ai-center" style="height: 100vh;">
    <p-card header="{{ t('labels.assessment_runner_administration') }}">

      <app-loader [loading]="loading"></app-loader>
      <ng-container *ngIf="loading !== true">
        <p-messages [(value)]="messages"></p-messages>

        <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
          <span class="p-inputgroup p-mb-2">
            <span class="p-inputgroup-addon"><i class="pi pi-user"></i></span>
            <input type="text" pInputText formControlName="email" placeholder="{{ t('labels.email') }}">
          </span>
          <span class="p-inputgroup p-mb-4">
            <span class="p-inputgroup-addon"><i class="pi pi-key"></i></span>
            <input type="password" pInputText formControlName="password" placeholder="{{ t('labels.password') }}">
          </span>
          <div class="p-grid">
            <div class="p-col-8" *ngIf="ssoActive === true">
              <button pButton type="button" (click)="gotoSSO()" label="{{ t('labels.sso_login') }}" class="p-button-secondary p-button-outlined"></button>
            </div>
            <div class="p-col-4 p-text-right" [ngClass]="{'p-col-12': ssoActive !== true}">
              <button pButton type="submit" label="{{ t('labels.login') }}" icon="pi pi-sign-in" class="p-button-success" [disabled]="busy === true"></button>
            </div>
          </div>
        </form>

        <hr>

        <p>
          <strong>{{ t('text.forgot_password') }}</strong><br>
          {{ t('text.then_you_can') }} <a [routerLink]="['/password']">{{ t('text.request_new_password') }}</a>
        </p>
      </ng-container>

    </p-card>

    <p class="p-text-center p-mt-4 sublink"><a href="/runner">{{ t('to_runner') }}<i class="pi pi-angle-right p-ml-1"></i></a></p>

  </div>
</ng-container>
